import React from 'react';
import styled from 'styled-components'

import { Box } from 'vqp-common'
import { Icon } from '../common'
import { CardTitle } from './'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Card = styled(Box)`
    padding: 25px 15px 0 15px;
    height: 295px;
    color: ${props => props.theme.colors[props.color]} !important;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Value = styled.div`
    font-size: 30px;
    font-weight: 700;
    padding-top: 25px;
`

const Desc = styled.div`
    margin-top: -10px;
    font-size: 12px;
    font-style: italic;
`

export const BigInfoCard = ({title, icon, color, descTop, valueTop, descBottom, valueBottom}) => (
    <Wrapper>
        <CardTitle>{title}</CardTitle>
        <Card color={color}>
            <Icon name={icon} stroke={color} fill={color} />
            <Value>{valueTop}</Value>
            <Desc>{descTop}</Desc>
            {valueBottom !== undefined && (
                <>
                    <Value>{valueBottom}</Value>
                    <Desc>{descBottom}</Desc>
                </>
            )}
        </Card>
    </Wrapper>
)

